import React from 'react';
import PT from 'prop-types';
import TranslatorManager from 'ts-translate-js';
import { Button, Textbox } from '../toolkit';

const tr = TranslatorManager.boundTR;
const tsapp = (typeof window != 'undefined') ? window.tsapp : undefined;

export class PromoCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            promoCode: "",
            isPromoCodeValid: false,
            hasError: false,
            presaleInfo: null
        };
    }

    componentDidMount() {
        this.checkForPresale();
    }

    checkForPresale() {
        if (this.props.promoPassword.IsPresale) {
            this.fetchPresaleInfo();
        }
    }

    fetchPresaleInfo() {
        const presaleInfoReq = tsapp.mvcapi.postCtl("/buyticket/promoinfo", {rstprv: this.props.promoPassword.content.secureCode});
        presaleInfoReq.
            success(function(data) {
                this.setState({presaleInfo: data.promoInfo});
                this.onPresaleInfoLoaded();
            }.bind(this))
            .notSuccess(function(error) {
                console.log(error);
            }.bind(this));
    }

    onPresaleInfoLoaded() {
        if (!this.state.presaleInfo.passwordNeeded) {
            this.redirectToSuccessPage();
        }
    }

    redirectToSuccessPage() {
        if (this.props.promoPassword.IsPresale) {
            window.location.href = `/events/${this.state.presaleInfo.eventID}`;
        } else {
            window.location.href = `/?promodefid=${this.state.promoDefId}`;
        }
    }

    onCodeChanged(code) {
        this.setState({promoCode: code});
    }

    onButtonClicked() {
        if (this.state.isPromoCodeValid) {
            this.redirectToSuccessPage();
        } else {
            this.validatePromoCode();
        }
    }

    validatePromoCode() {
        const validatePromoCodeP = tsapp.mvcapi.postCtl("/promocode/validateandactivatepromopwd", {
            promoPWD: this.state.promoCode,
            isForActivePresale: this.props.promoPassword.IsPresale,
            isForMembershipCard: false,
            promotionDefIDs: this.props.promoPassword.PromoDefIds
        });
        validatePromoCodeP
            .success(function(data) {
                this.setState({
                    isPromoCodeValid: true,
                    promoDefId: data.PromoDefID
                });
            }.bind(this))
            .notSuccess(function() {
                this.setState({
                    hasError: true
                });
            }.bind(this));
    }

    render() {
        const settingsContent = this.props.promoPassword.content;
        const successMessage = this.state.isPromoCodeValid ? (
            <span className="alert alert-success content-text">{settingsContent.validCodeMessage}</span>
        ) : null;
        const buttonTitle = this.state.isPromoCodeValid ? tr("Accéder à la liste des spectacles") : tr("Valider");
        const errorMessage = this.state.hasError ? (
            <div className="alert alert-danger content-text" style={{display: "block"}}>
                <span><b>{settingsContent.invalidCodeMessage}</b></span><br/>
                <span>{settingsContent.invalidCodeLongMessage}</span>
            </div>
        ) : null;

        return (
            <div>
                <h2>{settingsContent.welcomeMessage}</h2>
                <div className="spacer-row"></div>
                <div className="content-text">
                    <h4>{settingsContent.codeInputMessage}</h4>
                    <div className="smaller-spacer-row"></div>
                    <Textbox
                        id="promo-password"
                        type="text"
                        name="promo-password"
                        value={this.state.promoCode}
                        placeholder={settingsContent.placeholder}
                        onChange={this.onCodeChanged.bind(this)}
                        isInvalid={this.state.hasError}
                    />
                    {successMessage}
                    {errorMessage}
                    <div className="spacer-row"></div>
                    <Button
                        isSmall={!this.state.isPromoCodeValid} 
                        isLarge={this.state.isPromoCodeValid}
                        useSmallerFontSize={this.state.isPromoCodeValid}
                        onButtonClicked={this.onButtonClicked.bind(this)} 
                    >
                        <span>{buttonTitle}</span>
                    </Button>
                    <div className="spacer-row"></div>
                    <a href="/">{tr("Retourner à la vente standard")}</a>
                </div>
            </div>
        );
    }
}
PromoCode.propTypes = {
    promoPassword: PT.object
};
